import { render, staticRenderFns } from "./CommitteeMembersRearrange.vue?vue&type=template&id=0cf2d4b0"
import script from "./CommitteeMembersRearrange.vue?vue&type=script&lang=js"
export * from "./CommitteeMembersRearrange.vue?vue&type=script&lang=js"
import style0 from "./CommitteeMembersRearrange.vue?vue&type=style&index=0&id=0cf2d4b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports